import React from 'react';
import { Skull } from 'lucide-react';
import { createIframeGame } from './IframeGameActivity';

export default createIframeGame({
  id: 'kill-trump',
  displayName: 'Kill Trump',
  shortDescription: 'Single-player arcade shooter.',
  leaderboard: 'score',
  url: 'https://kill-trump.pages.dev/',
  icon: Skull,
  attribution: {
    text: 'Kill Trump — chimthuwu',
    license: 'See repository',
    href: 'https://kill-trump.pages.dev/',
  },
});
